// src/components/ContactForm.jsx
import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Alert,
  Stack,
} from "@mui/material";

export default function ContactForm() {
  const [values, setValues] = React.useState({ name: "", email: "", message: "" });
  const [status, setStatus] = React.useState({ ok: null, msg: "" });
  const [loading, setLoading] = React.useState(false);

  const onChange = (e) => setValues({ ...values, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ ok: null, msg: "" });
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        setStatus({ ok: true, msg: "Ευχαριστώ! Θα διαβάσω το μήνυμά σου." });
        setValues({ name: "", email: "", message: "" });
      } else {
        setStatus({
          ok: false,
          msg: data?.error || "Κάτι πήγε στραβά κατά την αποστολή.",
        });
      }
    } catch (err) {
      setStatus({
        ok: false,
        msg:
          (process.env.REACT_APP_API_URL
            ? `Αποτυχία σύνδεσης με ${process.env.REACT_APP_API_URL}/contact`
            : "Δεν έχει οριστεί REACT_APP_API_URL στο frontend.") +
          `\n${err.message}`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      elevation={8}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        boxShadow: "0 15px 40px rgba(0,0,0,0.18)",
      }}
    >
      {/* Gradient "κεφαλίδα" */}
      <Box
        sx={{
          p: 2.25,
          color: "#fff",
          background:
            "linear-gradient(90deg, rgba(14,165,233,0.95), rgba(34,197,94,0.95))",
        }}
      >
        <Typography variant="h6">Επικοινωνία</Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          Έχεις κάποια ιδέα ή εντόπισες κάποιο bug; Επικοινώνησε μαζί μου!
        </Typography>
      </Box>

      <CardContent sx={{ p: 3 }}>
        <form onSubmit={onSubmit}>
          <Stack spacing={2}>
            <TextField
              label="Όνομα"
              name="name"
              value={values.name}
              onChange={onChange}
              required
              fullWidth
            />
            <TextField
              label="Email"
              name="email"
              type="email"
              value={values.email}
              onChange={onChange}
              required
              fullWidth
            />
            <TextField
              label="Μήνυμα"
              name="message"
              value={values.message}
              onChange={onChange}
              required
              fullWidth
              multiline
              minRows={4}
            />

            <Box>
              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                sx={{ textTransform: "none" }}
              >
                Αποστολή
              </Button>
            </Box>

            {status.ok === true && <Alert severity="success">{status.msg}</Alert>}
            {status.ok === false && <Alert severity="error">{status.msg}</Alert>}
          </Stack>
        </form>
      </CardContent>
    </Card>
  );
}
